import { Tabs, TabsProps } from 'antd';
import { useTitle } from 'contexts/TitleProvider';
import Content from 'layouts/Content';
import { useEffect } from 'react';
import RewardConditionTab from './RewardConditionTab/RewardConditionTab';
import RewardFrameTab from './RewardFrameTab/RewardFrameTab';

const RewardCalculationSetupPage = () => {
  const { setTitle, setBreadcrumb } = useTitle();

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Điều kiện thưởng',
      children: <RewardConditionTab />,
    },
    {
      key: '2',
      label: 'Khung thưởng',
      children: <RewardFrameTab />,
    },
  ];

  useEffect(() => {
    setTitle('Thiết lập tính thưởng');
    setBreadcrumb([
      { title: 'Doanh thu/ Thưởng' },
      { title: 'Thiết lập tính thưởng' },
    ]);
  }, [setTitle, setBreadcrumb]);
  return (
    <Content className="!pt-3">
      <Tabs defaultActiveKey="1" items={items} />
    </Content>
  );
};

export default RewardCalculationSetupPage;
